import { useState, useEffect } from "react";

function removeCurrencySymbol(currencyString) {
  const currencyRegex = /(?:^\D+)|(?:\D+$)/;
  const currencySymbol = currencyString.match(currencyRegex)[0];
  const value = currencyString.replace(currencyRegex, "");
  return { currencySymbol, value };
}

const currencyParser = (currencyCode, country) => {
  const formattedPrice = window.formattedString.replace(/(0\.00|0,00|0)/, currencyCode);

  let priceObject = {
    symbolLeft: true,
    number: 0,
    cents: "00",
    symbol: "",
    hasCents: true,
  };

  let splitedValue;

  if (formattedPrice.includes("R ")) {
    const parts = formattedPrice.split(".");
    if (parts[0].length >= 3) {
      parts[0] = Number(parts[0]).toLocaleString();
    }
    splitedValue = ["R" + parts[0], parts[1]];
  } else {
    if (formattedPrice.includes(",")) {
      splitedValue = formattedPrice.split(",");
    } else {
      splitedValue = formattedPrice.split(".");
    }
  }

  const currencyRegex = /(?:^\D+)|(?:\D+$)/;
  const firstItemHasSymbol = currencyRegex.test(splitedValue[0].trim());

  if (firstItemHasSymbol) {
    const splitedFirstNumber = removeCurrencySymbol(splitedValue[0].trim());

    priceObject = {
      ...priceObject,
      symbolLeft: true,
      number: Number(splitedFirstNumber.value),
      cents: splitedValue[1] ? splitedValue[1] : "00",
      symbol: splitedFirstNumber.currencySymbol,
    };
  } else {
    const splitedSecondNumber = removeCurrencySymbol(splitedValue[1].trim());

    priceObject = {
      ...priceObject,
      symbolLeft: false,
      number: splitedValue[0],
      cents: splitedSecondNumber.value,
      symbol: splitedSecondNumber.currencySymbol.trim(),
    };
  }

  if (country === "JPY") {
    priceObject = {
      ...priceObject,
      hasCents: false,
    };
  }

  return priceObject;
};

const useReducedProductsPrice = (product, currencyCode) => {
  const [price, setPrice] = useState(null);
  const [promoPrice, setPromoPrice] = useState(null);
  const [oldPrice, setOldPrice] = useState(null);

  let priceObject;
  let promoPriceObject;

  useEffect(() => {
    setPrice(Number(product?.price).toFixed(2));
    setOldPrice(window.formattedString.replace(/(0\.00|0,00|0)/, product.old_price));
    setPromoPrice(Number(product?.promo_discounted_price).toFixed(2));
  }, []);

  // prices object returns currency symbol, cents & number as separate string

  priceObject = currencyParser(price, currencyCode);
  promoPriceObject = currencyParser(promoPrice, currencyCode);

  return { price, priceObject, promoPriceObject, oldPrice };
};

export { removeCurrencySymbol, currencyParser, useReducedProductsPrice };
